/** @format */
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';
import React from 'react';

import { EntryType } from '@toucan/client/core/contentful';

import {
    CollapsibleAside,
    CollapsibleAsideVariant,
} from '@toucan/client/blocks/components/collapsible-aside';

import { defaultDocumentOptions } from '../../helpers/options';
import { getRenderers } from '../../helpers/renderer';
import { ContentfulAccordionProps } from './types';

export const ContentfulAccordion = ({
    id,
    title,
    content,
}: ContentfulAccordionProps) => {
    const { json, links } = content;

    const options = {
        ...defaultDocumentOptions,
        renderNode: {
            ...defaultDocumentOptions.renderNode,
            [INLINES.EMBEDDED_ENTRY]: getRenderers(EntryType.INLINE, links),
        },
    };

    return (
        <CollapsibleAside
            data-testid="faq_accordion"
            className="accordion-faq"
            variant={CollapsibleAsideVariant.STANDALONE}
            key={id}
            title={title}
        >
            {documentToReactComponents(json, options)}
        </CollapsibleAside>
    );
};
